"use strict";

exports.__esModule = true;
exports.default = IconDanger;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

var _ = _interopRequireDefault(require("./"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _ref =
/*#__PURE__*/
(0, _core.jsx)("g", null, (0, _core.jsx)("path", {
  d: "M3.94 19.49h16.118a1 1 0 0 0 .866-1.498l-8.06-13.99a.996.996 0 0 0-1.732-.001L3.074 17.993a.998.998 0 0 0 .867 1.499zM12 17a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm1-3.503h-2v-5h2v5z"
}));
/* eslint-disable prettier/prettier */


function IconDanger(props) {
  var iconProps = _objectSpread({
    rtl: false
  }, props);

  return (0, _core.jsx)(_.default, iconProps, _ref);
}

IconDanger.displayName = 'IconDanger';
IconDanger.category = 'alert';